var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormViewer',{attrs:{"formId":_vm.f,"bulkState":_vm.b,"displayTitle":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }